import { ReactTFC, UnwrapReactComponent } from "../../../utils/fp/missing-ts-parts";
import React from "react";

import { css } from "@emotion/react";

import { styles } from "../shared-styles";
import { RelatedArticleSetComponent } from "../RelatedArticleSetComponent";

export const RelatedArticleSetBottom: ReactTFC<NonNullable<
  UnwrapReactComponent<typeof RelatedArticleSetComponent>["bottom"]
>> = props => {
  return (
    <React.Fragment>
      <span>{props.text}</span>
      {props.link && (
        <a
          href={props.link.link}
          css={css`
            color: var(--so-green);
            font-weight: 500;
            display: block;
          `}
        >
          {props.link.label}
        </a>
      )}
    </React.Fragment>
  );
};
